import React, { Component } from "react";
import { Row, Col, Form, Button, Card, Input, Radio, Spin } from "antd";
import CurrencyFormat from "react-currency-format";
import { connect } from "react-redux";
import Axios from "axios";
import axios from "../../../services/axios";
import {
  errorMessage,
  formatRupiah,
  getIntegerValueByKey,
  getFloatValueByKey,
} from "../../Utils";

let cancelToken;

const defaultPayload = {
  requestType: "Approved",
  isUnitKinto: false,
  mobilisasiUnit: {
    odooPrice: 0,
    trustPrice: 0,
    priceTotal: 0,
  },
  salesCommission: {
    odooPrice: 0,
    trustPrice: 0,
    priceTotal: 0,
  },
  isSourchingFee: false,
  isSellingFee: false,
  lelang: {
    odooPrice: 0,
    trustPrice: 0,
    priceTotal: 0,
  },
  generalRepair: {
    odooPrice: 0,
    trustPrice: 0,
    priceTotal: 0,
  },
  bodyRepair: {
    odooPrice: 0,
    trustPrice: 0,
    priceTotal: 0,
  },
  biayaPajakSTNK: {
    odooPrice: 0,
    trustPrice: 0,
    priceTotal: 0,
  },
  bbmStockUnit: {
    odooPrice: 0,
    trustPrice: 0,
    priceTotal: 0,
  },
  others: {
    odooPrice: 0,
    trustPrice: 0,
    priceTotal: 0,
  },
  discount: { priceTotal: 0, discount: 0 },
  discountSubsidiDP: { priceTotal: 0, discount: 0 },
  approvalDiscount: 0,
  unitPurchase: 0,
  unitKinto: 0,
  sourchingFee: 0,
  sellingFee: 0,
  totalCost: 0,
  profit: { priceTotal: 0, profitPercent: 0 },
  mSourcingFeePercent: 1.5,
  mSellingFeePercent: 1.5,
  mUnitKintoPercent: 11,
  mProfitPercent: 5,
};

const defaultPayloadSearch = {
  licensePlate: "",
  salesOtr: "",
};

class EApprovalSearchLicensePlate extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isLoading: false,
      isDefault: false,
      isPPN: true,
      isSourcing: false,
      isSelling: false,
      isCheck: false,
      rawData: null,
      payload: defaultPayload,
      payloadSearch: defaultPayloadSearch,
      sourchingFeePercentage: 1.5,
      sellingFeePercentage: 1.5,
    };
  }

  defaultValueContent = (value) => {
    return (
      <Row>
        <Col span={6}></Col>
        <Col span={18}>
          <p style={{ margin: 0 }}>{formatRupiah(value)}</p>
        </Col>
      </Row>
    );
  };

  radioContent = (value, isStatus) => {
    return (
      <Row>
        <Col span={6}></Col>
        <Col span={18}>
          <Radio.Group
            style={{ margin: "5px 0" }}
            // disabled={rawData ? rawData.status !== "New" ? true : false : true}
            value={isStatus}
            onChange={(event) => this.handleRadio(event.target.value, value)}>
            <Radio value={1}>Yes</Radio>
            <Radio value={0}>No</Radio>
          </Radio.Group>
        </Col>
      </Row>
    );
  };

  async fetchData() {
    const { payloadSearch } = this.state;
    this.setState({
      isLoading: true,
      isCheck: false,
      rawData: null,
      payload: defaultPayload,
    });

    if (cancelToken) {
      cancelToken.cancel("Operation canceled due to new request");
    }
    cancelToken = Axios.CancelToken.source();

    await axios
      .post(`car-sales/simulation`, payloadSearch)
      .then((result) => {
        this.setState({
          rawData: result.data.carSale,
          isLoading: false,
          isCheck: true,
        });

        if (result.data) {
          this.convertDataCalculationDetail(result.data.carSale);
        }
      })
      .catch((err) => {
        if (!Axios.isCancel(err)) {
          errorMessage(err.response || err);
          this.setState({ isLoading: false, isCheck: false });
        }
      });
  }

  convertDataCalculationDetail = (datas) => {
    let { payload } = this.state;

    payload.mSourcingFeePercent = datas.mSourcingFeePercent || 1.5;
    payload.mSellingFeePercent = datas.mSellingFeePercent || 1.5;
    payload.mUnitKintoPercent = datas.mUnitKintoPercent || 11;
    payload.mProfitPercent = datas.mProfitPercent || 5;

    datas.calculationDetail &&
      datas.calculationDetail.map((item) => {
        switch (item.name) {
          case "OTR":
            payload.otr = item.priceTotal;
            break;
          case "Sales Revenue":
            payload.salesRevenue = item.priceTotal;
            break;
          case "DPP":
            payload.dpp = item.priceTotal;
            break;
          case "Unit Purchase":
            payload.unitPurchase = item.priceTotal;
            break;
          case "Unit Kinto PPN":
            payload.unitKintoData = item;
            payload.unitKinto = item.isStatus ? item.priceTotal : 0;
            payload.isUnitKinto = item.isStatus ? 1 : 0;
            break;
          case "Mobilisasi Unit":
            payload.mobilisasiUnit = item;
            break;
          case "Sales Commission":
            payload.salesCommission = item;
            break;
          case "Sourching Fee":
            payload.sourchingFeeData = item;
            payload.sourchingFee = item.isStatus ? item.priceTotal : 0;
            payload.isSourchingFee =
              datas.status !== "New" ? (item.isStatus ? 1 : 0) : null;
            break;
          case "Selling Fee":
            payload.sellingFeeData = item;
            payload.sellingFee = item.isStatus ? item.priceTotal : 0;
            payload.isSellingFee =
              datas.status !== "New" ? (item.isStatus ? 1 : 0) : null;
            break;
          case "Lelang":
            payload.lelang = item;
            break;
          case "General Repair":
            payload.generalRepair = item;
            break;
          case "Body Repair":
            payload.bodyRepair = item;
            break;
          case "Biaya Pajak STNK":
            payload.biayaPajakSTNK = item;
            break;
          case "BBM Stock Unit":
            payload.bbmStockUnit = item;
            break;
          case "Others":
            payload.others = item;
            break;
          case "Total Cost":
            payload.totalCost = item.priceTotal;
            break;
          case "Available Margin":
            payload.availableMargin = item.priceTotal;
            break;
          case "Discounts - Subsidi DP":
            payload.discountSubsidiDP = item;
            break;
          case "Discounts":
            payload.discount = item;
            break;
          case "Profit":
            payload.profit = item;
            break;
          case "Kilometer":
            payload.kilometer = item.value;
            break;
          case "Stock Days":
            payload.stockDays = item.value;
            break;
          default:
            break;
        }
      });

    console.log(payload);

    this.setState({
      isSourcing: datas.status !== "New",
      isSelling: datas.status !== "New",
      payload,
    });
  };

  handleRadio = (value, type) => {
    let { payload } = this.state;
    let unit_purchase = payload.unitPurchase ? payload.unitPurchase : 0;
    let salesRevenue = payload.salesRevenue ? payload.salesRevenue : 0;

    switch (type) {
      case "kinto":
        let unitKinto = parseInt(
          (unit_purchase * (payload.mUnitKintoPercent || 11)) / 100
        );
        this.setState(
          { payload: { ...payload, isUnitKinto: value }, isPPN: true },
          () => this.calculateData("unitKinto", value === 1 ? unitKinto : 0)
        );
        break;
      case "sourcing":
        // let sourchingPercent =
        //   sourchingFeePercentage === "" ? 0 : Number(sourchingFeePercentage);
        let sourchingFee = parseInt(
          (unit_purchase * (payload.mSourcingFeePercent || 1.5)) / 100
        );
        this.setState(
          { payload: { ...payload, isSourchingFee: value }, isSourcing: true },
          () =>
            this.calculateData("sourchingFee", value === 1 ? sourchingFee : 0)
        );
        break;
      case "selling":
        // let sellingPercent =
        //   sellingFeePercentage === "" ? 0 : Number(sellingFeePercentage);
        let sellingFee =
          parseInt(salesRevenue * (payload.mSellingFeePercent || 1.5)) / 100;
        this.setState(
          {
            payload: { ...payload, isSellingFee: value },
            isSelling: true,
            isDefault: false,
          },
          () => this.calculateData("sellingFee", value === 1 ? sellingFee : 0)
        );
        break;
      default:
        break;
    }
  };

  calculateData = (type, value) => {
    let values = !isNaN(value) ? value : 0;
    let payload = Object.assign([], this.state.payload);
    let radioField = ["unitKinto", "sourchingFee", "sellingFee"];
    if (radioField.includes(type)) {
      payload[type] = values;
    } else if (type === "discountSubsidiDP") {
      payload[type] = {
        ...payload.discountSubsidiDP,
        priceTotal: values,
        discount: parseFloat(((values / payload.dpp) * 100).toFixed(2)),
      };
    } else {
      payload[type] = {
        ...payload[type],
        trustPrice: values,
        priceTotal: payload[type].odooPrice + values,
      };
    }
    let {
      dpp,
      profit,
      unitPurchase,
      unitKinto,
      mobilisasiUnit,
      salesCommission,
      sourchingFee,
      sellingFee,
      lelang,
      generalRepair,
      bodyRepair,
      biayaPajakSTNK,
      bbmStockUnit,
      others,
      discountSubsidiDP,
    } = payload;

    let totalCost =
      unitPurchase +
      unitKinto +
      mobilisasiUnit.priceTotal +
      salesCommission.priceTotal +
      sourchingFee +
      sellingFee +
      lelang.priceTotal +
      generalRepair.priceTotal +
      bodyRepair.priceTotal +
      biayaPajakSTNK.priceTotal +
      bbmStockUnit.priceTotal +
      others.priceTotal;

    let availableMargin = dpp - totalCost;
    let priceTotal = availableMargin - discountSubsidiDP.priceTotal;
    let profitPercent = parseFloat(((priceTotal / dpp) * 100).toFixed(2));
    if (dpp == 0) profitPercent = 0;

    this.setState({
      payload: {
        ...payload,
        totalCost,
        availableMargin,
        profit: { ...profit, profitPercent, priceTotal },
      },
    });
  };

  render() {
    const {
      rawData,
      payload,
      payloadSearch,
      isLoading,
      isPPN,
      isSourcing,
      isSelling,
      isCheck,
      sourchingFeePercentage,
      sellingFeePercentage,
    } = this.state;
    return (
      <div>
        <Row gutter={{ xs: 8, sm: 16, md: 24, lg: 32 }}>
          <Col className="gutter-row" span={24} style={{ marginTop: 35 }}>
            <Card title="Pencarian Nopol">
              <Spin tip="Sedang mengambil data" spinning={isLoading}>
                <Form>
                  {isCheck ? (
                    <Row
                      gutter={{ xs: 8, sm: 16, md: 24, lg: 32 }}
                      justify={"end"}>
                      <Col className="gutter-row" span={24}>
                        <h4 style={{ textAlign: "right" }}>
                          Stock Days:{" "}
                          {payload && payload.stockDays ? payload.stockDays : 0}
                        </h4>
                        <h4
                          style={{ textAlign: "right", fontWeight: "normal" }}>
                          Km:{" "}
                          <CurrencyFormat
                            value={getIntegerValueByKey(payload, "kilometer")}
                            displayType={"text"}
                            decimalSeparator={","}
                            thousandSeparator={"."}
                          />
                        </h4>
                      </Col>
                    </Row>
                  ) : null}

                  <Row gutter={{ xs: 8, sm: 16, md: 24, lg: 32 }}>
                    <Col
                      className="gutter-row"
                      span={4}
                      style={{ paddingRight: 0 }}>
                      <div>No Polisi</div>
                      <Row
                        type="flex"
                        style={{
                          paddingTop: 5,
                          paddingBottom: 5,
                          paddingLeft: 0,
                          paddingRight: 0,
                        }}>
                        <Col span={24}>
                          <Input
                            placeholder={"Input No Polisi Here"}
                            value={
                              payloadSearch.licensePlate
                                ? payloadSearch.licensePlate.toUpperCase()
                                : ""
                            }
                            onChange={(event) =>
                              this.setState({
                                payloadSearch: {
                                  ...payloadSearch,
                                  licensePlate:
                                    event.target.value.toUpperCase(),
                                },
                              })
                            }
                          />
                        </Col>
                      </Row>
                    </Col>
                    <Col className="gutter-row" span={12}>
                      <div>OTR</div>
                      <Row
                        type="flex"
                        style={{
                          paddingTop: 5,
                          paddingBottom: 5,
                          paddingLeft: 0,
                          paddingRight: 0,
                        }}>
                        <Col span={8}>
                          <CurrencyFormat
                            style={{
                              border: "1px solid #d9d9d9",
                              borderRadius: "4px",
                              width: "100%",
                              paddingTop: 5,
                              paddingBottom: 4,
                              paddingRight: 5,
                              paddingLeft: 5,
                            }}
                            value={getIntegerValueByKey(
                              payloadSearch,
                              "salesOtr"
                            )}
                            thousandSeparator={"."}
                            decimalSeparator={","}
                            prefix={"Rp "}
                            placeholder={"Rp 0"}
                            onValueChange={(values) => {
                              const { formattedValue, value, floatValue } =
                                values;
                              this.setState({
                                payloadSearch: {
                                  ...payloadSearch,
                                  salesOtr: value,
                                },
                              });
                            }}
                          />
                        </Col>
                        <Col span={4}>
                          <Button
                            htmlType="button"
                            type="primary"
                            loading={isLoading}
                            style={{ marginLeft: 16 }}
                            onClick={() => this.fetchData()}>
                            Search
                          </Button>
                        </Col>
                      </Row>
                    </Col>
                  </Row>

                  {isCheck ? (
                    <div style={{ marginTop: 20, marginBottom: 20 }}>
                      <h4>Nama Unit</h4>
                      <h5>{rawData ? rawData.carName : "-"}</h5>
                    </div>
                  ) : null}

                  {isCheck ? (
                    <div
                      style={{
                        borderRadius: 10,
                        backgroundColor: "#EFF2F5",
                        padding: 15,
                      }}>
                      <Row gutter={{ xs: 8, sm: 16, md: 24, lg: 32 }}>
                        <Col className="gutter-row" span={12}>
                          <div>
                            <h4>OTR</h4>
                            <h4>Sales Revenue</h4>
                            <h4>DPP</h4>
                          </div>
                        </Col>
                        <Col className="gutter-row" span={12}>
                          <div style={{ textAlign: "right" }}>
                            <h4>
                              <CurrencyFormat
                                style={{ fontWeight: "normal" }}
                                value={getIntegerValueByKey(rawData, "otr")}
                                displayType={"text"}
                                decimalSeparator={","}
                                thousandSeparator={"."}
                                prefix={"Rp "}
                              />
                            </h4>
                            <h4>
                              <CurrencyFormat
                                style={{ fontWeight: "normal" }}
                                value={getIntegerValueByKey(
                                  payload,
                                  "salesRevenue"
                                )}
                                displayType={"text"}
                                decimalSeparator={","}
                                thousandSeparator={"."}
                                prefix={"Rp "}
                              />
                            </h4>
                            <h4>
                              <CurrencyFormat
                                style={{ fontWeight: "normal" }}
                                value={getIntegerValueByKey(payload, "dpp")}
                                displayType={"text"}
                                decimalSeparator={","}
                                thousandSeparator={"."}
                                prefix={"Rp "}
                              />
                            </h4>
                          </div>
                        </Col>
                      </Row>
                    </div>
                  ) : null}

                  {isCheck ? (
                    <div style={{ margin: "20px 0" }}>
                      <h4>Cost:</h4>
                      <div
                        style={{
                          borderRadius: 10,
                          backgroundColor: "#EFF2F5",
                          padding: 15,
                        }}>
                        <Row
                          gutter={{ xs: 8, sm: 16, md: 24, lg: 32 }}
                          justify="space-between"
                          align="middle">
                          <Col className="gutter-row" span={6}>
                            <p style={{ marginBottom: 0 }}>Unit Purchase</p>
                          </Col>
                          <Col className="gutter-row" span={6}>
                            {this.defaultValueContent(payload.unitPurchase)}
                          </Col>
                          <Col className="gutter-row" span={6}>
                            <p style={{ marginBottom: 0 }}> </p>
                          </Col>
                          <Col className="gutter-row" span={6}>
                            <div style={{ textAlign: "right" }}>
                              <p>
                                <CurrencyFormat
                                  style={{ marginBottom: 0 }}
                                  value={getIntegerValueByKey(
                                    payload,
                                    "unitPurchase"
                                  )}
                                  displayType={"text"}
                                  decimalSeparator={","}
                                  thousandSeparator={"."}
                                  prefix={"Rp "}
                                />
                              </p>
                            </div>
                          </Col>
                        </Row>

                        <Row
                          gutter={{ xs: 8, sm: 16, md: 24, lg: 32 }}
                          justify="space-between"
                          align="middle"
                          style={{ display: "flex", alignItems: "center" }}>
                          <Col className="gutter-row" span={6}>
                            <p style={{ marginBottom: 0 }}>
                              Unit Kinto (PPN) ({payload.mUnitKintoPercent}%){" "}
                            </p>
                          </Col>
                          <Col className="gutter-row" span={6}>
                            {this.radioContent("kinto", payload.isUnitKinto)}
                          </Col>
                          <Col className="gutter-row" span={6}>
                            <CurrencyFormat
                              style={{
                                border: "1px solid #d9d9d9",
                                borderRadius: "5px",
                                width: "100%",
                                margin: "2px 0",
                              }}
                              value={getIntegerValueByKey(payload, "unitKinto")}
                              thousandSeparator={"."}
                              decimalSeparator={","}
                              prefix={"Rp "}
                              placeholder={"Rp 0"}
                              disabled={true}
                              onValueChange={(values) => {
                                const { formattedValue, value, floatValue } =
                                  values;
                                this.setState({
                                  payload: {
                                    ...payload,
                                    unitKinto: floatValue,
                                  },
                                });
                              }}
                            />
                          </Col>
                          <Col className="gutter-row" span={6}>
                            <div style={{ textAlign: "right" }}>
                              <p>
                                <CurrencyFormat
                                  style={{
                                    fontWeight: "normal",
                                    marginBottom: 0,
                                  }}
                                  value={getIntegerValueByKey(
                                    payload,
                                    "unitKinto"
                                  )}
                                  displayType={"text"}
                                  decimalSeparator={","}
                                  thousandSeparator={"."}
                                  prefix={"Rp "}
                                />
                              </p>
                            </div>
                          </Col>
                        </Row>

                        {isPPN ? (
                          <div>
                            <Row
                              gutter={{ xs: 8, sm: 16, md: 24, lg: 32 }}
                              justify="space-between"
                              align="middle"
                              style={{ display: "flex", alignItems: "center" }}>
                              <Col className="gutter-row" span={6}>
                                <p style={{ marginBottom: 0 }}>
                                  Mobilisasi Unit
                                </p>
                              </Col>
                              <Col className="gutter-row" span={6}>
                                {this.defaultValueContent(
                                  getIntegerValueByKey(
                                    payload,
                                    "mobilisasiUnit.odooPrice"
                                  )
                                )}
                              </Col>
                              <Col className="gutter-row" span={6}>
                                <CurrencyFormat
                                  style={{
                                    border: "1px solid #d9d9d9",
                                    borderRadius: "5px",
                                    width: "100%",
                                    margin: "2px 0",
                                  }}
                                  value={getIntegerValueByKey(
                                    payload,
                                    "mobilisasiUnit.trustPrice"
                                  )}
                                  thousandSeparator={"."}
                                  decimalSeparator={","}
                                  prefix={"Rp "}
                                  placeholder={"Rp 0"}
                                  // disabled={rawData ? (rawData.isAgree || rawData.status !== "New") ? true : false : true}
                                  onValueChange={(values) => {
                                    const {
                                      formattedValue,
                                      value,
                                      floatValue,
                                    } = values;
                                    this.calculateData(
                                      "mobilisasiUnit",
                                      floatValue
                                    );
                                  }}
                                />
                              </Col>
                              <Col className="gutter-row" span={6}>
                                <div style={{ textAlign: "right" }}>
                                  <p>
                                    <CurrencyFormat
                                      style={{
                                        fontWeight: "normal",
                                        marginBottom: 0,
                                      }}
                                      value={getIntegerValueByKey(
                                        payload,
                                        "mobilisasiUnit.priceTotal"
                                      )}
                                      displayType={"text"}
                                      decimalSeparator={","}
                                      thousandSeparator={"."}
                                      prefix={"Rp "}
                                    />
                                  </p>
                                </div>
                              </Col>
                            </Row>

                            <Row
                              gutter={{ xs: 8, sm: 16, md: 24, lg: 32 }}
                              justify="space-between"
                              align="middle"
                              style={{ display: "flex", alignItems: "center" }}>
                              <Col className="gutter-row" span={6}>
                                <p style={{ marginBottom: 0 }}>
                                  Sales Commision
                                </p>
                              </Col>
                              <Col className="gutter-row" span={6}>
                                {this.defaultValueContent(
                                  defaultPayload.salesCommission.odooPrice
                                )}
                              </Col>
                              <Col className="gutter-row" span={6}>
                                <CurrencyFormat
                                  style={{
                                    border: "1px solid #d9d9d9",
                                    borderRadius: "5px",
                                    width: "100%",
                                    margin: "2px 0",
                                  }}
                                  value={getIntegerValueByKey(
                                    payload,
                                    "salesCommission.trustPrice"
                                  )}
                                  thousandSeparator={"."}
                                  decimalSeparator={","}
                                  prefix={"Rp "}
                                  placeholder={"Rp 0"}
                                  // disabled={rawData ? (rawData.isAgree || rawData.status !== "New") ? true : false : true}
                                  onValueChange={(values) => {
                                    const {
                                      formattedValue,
                                      value,
                                      floatValue,
                                    } = values;
                                    this.calculateData(
                                      "salesCommission",
                                      floatValue
                                    );
                                  }}
                                />
                              </Col>
                              <Col className="gutter-row" span={6}>
                                <div style={{ textAlign: "right" }}>
                                  <p>
                                    <CurrencyFormat
                                      style={{
                                        fontWeight: "normal",
                                        marginBottom: 0,
                                      }}
                                      value={getIntegerValueByKey(
                                        payload,
                                        "salesCommission.priceTotal"
                                      )}
                                      displayType={"text"}
                                      decimalSeparator={","}
                                      thousandSeparator={"."}
                                      prefix={"Rp "}
                                    />
                                  </p>
                                </div>
                              </Col>
                            </Row>

                            <Row
                              gutter={{ xs: 8, sm: 16, md: 24, lg: 32 }}
                              justify="space-between"
                              align="middle"
                              style={{ display: "flex", alignItems: "center" }}>
                              <Col className="gutter-row" span={6}>
                                <Row
                                  type="flex"
                                  justify="start"
                                  style={{ alignItems: "center" }}>
                                  <Col span={12}>
                                    <p style={{ marginBottom: 0 }}>
                                      Sourcing Fee
                                    </p>
                                  </Col>
                                  <Col span={12}>
                                    <div
                                      style={{
                                        display: "flex",
                                        alignItems: "center",
                                      }}>
                                      <Input
                                        style={{ width: 100 }}
                                        type={"number"}
                                        value={payload.mSourcingFeePercent}
                                        disabled={true}
                                      />
                                      <div
                                        style={{
                                          paddingTop: 10,
                                          paddingBottom: 10,
                                          paddingLeft: 5,
                                          paddingRight: 5,
                                          zIndex: 99,
                                          marginLeft: -30,
                                        }}>
                                        %
                                      </div>
                                    </div>
                                  </Col>
                                </Row>
                              </Col>
                              <Col className="gutter-row" span={6}>
                                {this.radioContent(
                                  "sourcing",
                                  payload.isSourchingFee
                                )}
                              </Col>
                              <Col className="gutter-row" span={6}>
                                <CurrencyFormat
                                  style={{
                                    border: "1px solid #d9d9d9",
                                    borderRadius: "5px",
                                    width: "100%",
                                    margin: "2px 0",
                                  }}
                                  value={getIntegerValueByKey(
                                    payload,
                                    "sourchingFee"
                                  )}
                                  thousandSeparator={"."}
                                  decimalSeparator={","}
                                  prefix={"Rp "}
                                  placeholder={"Rp 0"}
                                  disabled={true}
                                  onValueChange={(values) => {
                                    const {
                                      formattedValue,
                                      value,
                                      floatValue,
                                    } = values;
                                    this.calculateData(
                                      "sourchingFee",
                                      floatValue
                                    );
                                  }}
                                />
                              </Col>
                              <Col className="gutter-row" span={6}>
                                <div style={{ textAlign: "right" }}>
                                  <p>
                                    <CurrencyFormat
                                      style={{
                                        fontWeight: "normal",
                                        marginBottom: 0,
                                      }}
                                      value={getIntegerValueByKey(
                                        payload,
                                        "sourchingFee"
                                      )}
                                      displayType={"text"}
                                      decimalSeparator={","}
                                      thousandSeparator={"."}
                                      prefix={"Rp "}
                                    />
                                  </p>
                                </div>
                              </Col>
                            </Row>

                            {isSourcing ? (
                              <Row
                                gutter={{ xs: 8, sm: 16, md: 24, lg: 32 }}
                                justify="space-between"
                                align="middle"
                                style={{
                                  display: "flex",
                                  alignItems: "center",
                                }}>
                                <Col className="gutter-row" span={6}>
                                  {isSourcing ? (
                                    <Row
                                      type="flex"
                                      justify="start"
                                      style={{ alignItems: "center" }}>
                                      <Col span={12}>
                                        <p style={{ marginBottom: 0 }}>
                                          Selling Fee
                                        </p>
                                      </Col>
                                      <Col span={12}>
                                        <div
                                          style={{
                                            display: "flex",
                                            alignItems: "center",
                                          }}>
                                          <Input
                                            style={{ width: 100 }}
                                            type={"number"}
                                            value={payload.mSellingFeePercent}
                                            disabled={true}
                                          />
                                          <div
                                            style={{
                                              paddingTop: 10,
                                              paddingBottom: 10,
                                              paddingLeft: 5,
                                              paddingRight: 5,
                                              zIndex: 99,
                                              marginLeft: -30,
                                            }}>
                                            %
                                          </div>
                                        </div>
                                      </Col>
                                    </Row>
                                  ) : null}
                                </Col>
                                <Col className="gutter-row" span={6}>
                                  {isSourcing
                                    ? this.radioContent(
                                        "selling",
                                        payload.isSellingFee
                                      )
                                    : null}
                                </Col>
                                <Col className="gutter-row" span={6}>
                                  {isSourcing ? (
                                    <CurrencyFormat
                                      style={{
                                        border: "1px solid #d9d9d9",
                                        borderRadius: "5px",
                                        width: "100%",
                                        margin: "2px 0",
                                      }}
                                      value={getIntegerValueByKey(
                                        payload,
                                        "sellingFee"
                                      )}
                                      thousandSeparator={"."}
                                      decimalSeparator={","}
                                      prefix={"Rp "}
                                      placeholder={"Rp 0"}
                                      disabled={true}
                                      onValueChange={(values) => {
                                        const {
                                          formattedValue,
                                          value,
                                          floatValue,
                                        } = values;
                                        this.calculateData(
                                          "sellingFee",
                                          floatValue
                                        );
                                      }}
                                    />
                                  ) : null}
                                </Col>
                                <Col className="gutter-row" span={6}>
                                  <div style={{ textAlign: "right" }}>
                                    {isSourcing ? (
                                      <p style={{ marginBottom: 0 }}>
                                        <CurrencyFormat
                                          value={getIntegerValueByKey(
                                            payload,
                                            "sellingFee"
                                          )}
                                          thousandSeparator={"."}
                                          decimalSeparator={","}
                                          prefix={"Rp "}
                                          displayType={"text"}
                                        />
                                      </p>
                                    ) : null}
                                  </div>
                                </Col>
                              </Row>
                            ) : null}

                            {isSelling ? (
                              <div>
                                <Row
                                  gutter={{ xs: 8, sm: 16, md: 24, lg: 32 }}
                                  justify="space-between"
                                  align="middle"
                                  style={{
                                    display: "flex",
                                    alignItems: "center",
                                  }}>
                                  <Col className="gutter-row" span={6}>
                                    <p style={{ marginBottom: 0 }}>Lelang</p>
                                  </Col>
                                  <Col className="gutter-row" span={6}>
                                    {this.defaultValueContent(
                                      defaultPayload.lelang.odooPrice
                                    )}
                                  </Col>
                                  <Col className="gutter-row" span={6}>
                                    <CurrencyFormat
                                      style={{
                                        border: "1px solid #d9d9d9",
                                        borderRadius: "5px",
                                        width: "100%",
                                        margin: "2px 0",
                                      }}
                                      value={getIntegerValueByKey(
                                        payload,
                                        "lelang.trustPrice"
                                      )}
                                      thousandSeparator={"."}
                                      decimalSeparator={","}
                                      prefix={"Rp "}
                                      placeholder={"Rp 0"}
                                      // disabled={rawData ? (rawData.isAgree || rawData.status !== "New") ? true : false : true}
                                      onValueChange={(values) => {
                                        const {
                                          formattedValue,
                                          value,
                                          floatValue,
                                        } = values;
                                        this.calculateData(
                                          "lelang",
                                          floatValue
                                        );
                                      }}
                                    />
                                  </Col>
                                  <Col className="gutter-row" span={6}>
                                    <div style={{ textAlign: "right" }}>
                                      <p>
                                        <CurrencyFormat
                                          style={{ marginBottom: 0 }}
                                          value={getIntegerValueByKey(
                                            payload,
                                            "lelang.priceTotal"
                                          )}
                                          displayType={"text"}
                                          decimalSeparator={","}
                                          thousandSeparator={"."}
                                          prefix={"Rp "}
                                        />
                                      </p>
                                    </div>
                                  </Col>
                                </Row>
                                <Row
                                  gutter={{ xs: 8, sm: 16, md: 24, lg: 32 }}
                                  justify="space-between"
                                  align="middle"
                                  style={{
                                    display: "flex",
                                    alignItems: "center",
                                  }}>
                                  <Col className="gutter-row" span={6}>
                                    <p style={{ margin: 0 }}>General Repair</p>
                                  </Col>
                                  <Col className="gutter-row" span={6}>
                                    {this.defaultValueContent(
                                      defaultPayload.generalRepair.odooPrice
                                    )}
                                  </Col>
                                  <Col className="gutter-row" span={6}>
                                    <CurrencyFormat
                                      style={{
                                        border: "1px solid #d9d9d9",
                                        borderRadius: "5px",
                                        width: "100%",
                                        margin: "2px 0",
                                      }}
                                      value={getIntegerValueByKey(
                                        payload,
                                        "generalRepair.trustPrice"
                                      )}
                                      thousandSeparator={"."}
                                      decimalSeparator={","}
                                      prefix={"Rp "}
                                      placeholder={"Rp 0"}
                                      // disabled={rawData ? (rawData.isAgree || rawData.status !== "New") ? true : false : true}
                                      onValueChange={(values) => {
                                        const {
                                          formattedValue,
                                          value,
                                          floatValue,
                                        } = values;
                                        this.calculateData(
                                          "generalRepair",
                                          floatValue
                                        );
                                      }}
                                    />
                                  </Col>
                                  <Col className="gutter-row" span={6}>
                                    <div style={{ textAlign: "right" }}>
                                      <p>
                                        <CurrencyFormat
                                          style={{ marginBottom: 0 }}
                                          value={getIntegerValueByKey(
                                            payload,
                                            "generalRepair.priceTotal"
                                          )}
                                          displayType={"text"}
                                          decimalSeparator={","}
                                          thousandSeparator={"."}
                                          prefix={"Rp "}
                                        />
                                      </p>
                                    </div>
                                  </Col>
                                </Row>
                                <Row
                                  gutter={{ xs: 8, sm: 16, md: 24, lg: 32 }}
                                  justify="space-between"
                                  align="middle"
                                  style={{
                                    display: "flex",
                                    alignItems: "center",
                                  }}>
                                  <Col className="gutter-row" span={6}>
                                    <p style={{ marginBottom: 0 }}>
                                      Body Repair
                                    </p>
                                  </Col>
                                  <Col className="gutter-row" span={6}>
                                    {this.defaultValueContent(
                                      defaultPayload.bodyRepair.odooPrice
                                    )}
                                  </Col>
                                  <Col className="gutter-row" span={6}>
                                    <CurrencyFormat
                                      style={{
                                        border: "1px solid #d9d9d9",
                                        borderRadius: "5px",
                                        width: "100%",
                                        margin: "2px 0",
                                      }}
                                      value={getIntegerValueByKey(
                                        payload,
                                        "bodyRepair.trustPrice"
                                      )}
                                      thousandSeparator={"."}
                                      decimalSeparator={","}
                                      prefix={"Rp "}
                                      placeholder={"Rp 0"}
                                      // disabled={rawData ? (rawData.isAgree || rawData.status !== "New") ? true : false : true}
                                      onValueChange={(values) => {
                                        const {
                                          formattedValue,
                                          value,
                                          floatValue,
                                        } = values;
                                        this.calculateData(
                                          "bodyRepair",
                                          floatValue
                                        );
                                      }}
                                    />
                                  </Col>
                                  <Col className="gutter-row" span={6}>
                                    <div style={{ textAlign: "right" }}>
                                      <p>
                                        <CurrencyFormat
                                          style={{ marginBottom: 0 }}
                                          value={getIntegerValueByKey(
                                            payload,
                                            "bodyRepair.priceTotal"
                                          )}
                                          displayType={"text"}
                                          decimalSeparator={","}
                                          thousandSeparator={"."}
                                          prefix={"Rp "}
                                        />
                                      </p>
                                    </div>
                                  </Col>
                                </Row>
                                <Row
                                  gutter={{ xs: 8, sm: 16, md: 24, lg: 32 }}
                                  justify="space-between"
                                  align="middle"
                                  style={{
                                    display: "flex",
                                    alignItems: "center",
                                  }}>
                                  <Col className="gutter-row" span={6}>
                                    <p style={{ marginBottom: 0 }}>
                                      Biaya Pajak STNK
                                    </p>
                                  </Col>
                                  <Col className="gutter-row" span={6}>
                                    {this.defaultValueContent(
                                      defaultPayload.biayaPajakSTNK.odooPrice
                                    )}
                                  </Col>
                                  <Col className="gutter-row" span={6}>
                                    <CurrencyFormat
                                      style={{
                                        border: "1px solid #d9d9d9",
                                        borderRadius: "5px",
                                        width: "100%",
                                        margin: "2px 0",
                                      }}
                                      value={getIntegerValueByKey(
                                        payload,
                                        "biayaPajakSTNK.trustPrice"
                                      )}
                                      thousandSeparator={"."}
                                      decimalSeparator={","}
                                      prefix={"Rp "}
                                      placeholder={"Rp 0"}
                                      // disabled={rawData ? (rawData.isAgree || rawData.status !== "New") ? true : false : true}
                                      onValueChange={(values) => {
                                        const {
                                          formattedValue,
                                          value,
                                          floatValue,
                                        } = values;
                                        this.calculateData(
                                          "biayaPajakSTNK",
                                          floatValue
                                        );
                                      }}
                                    />
                                  </Col>
                                  <Col className="gutter-row" span={6}>
                                    <div style={{ textAlign: "right" }}>
                                      <p>
                                        <CurrencyFormat
                                          style={{ marginBottom: 0 }}
                                          value={getIntegerValueByKey(
                                            payload,
                                            "biayaPajakSTNK.priceTotal"
                                          )}
                                          displayType={"text"}
                                          decimalSeparator={","}
                                          thousandSeparator={"."}
                                          prefix={"Rp "}
                                        />
                                      </p>
                                    </div>
                                  </Col>
                                </Row>
                                <Row
                                  gutter={{ xs: 8, sm: 16, md: 24, lg: 32 }}
                                  justify="space-between"
                                  align="middle"
                                  style={{
                                    display: "flex",
                                    alignItems: "center",
                                  }}>
                                  <Col className="gutter-row" span={6}>
                                    <p style={{ marginBottom: 0 }}>
                                      BBM Stock Unit
                                    </p>
                                  </Col>
                                  <Col className="gutter-row" span={6}>
                                    {this.defaultValueContent(
                                      defaultPayload.bbmStockUnit.odooPrice
                                    )}
                                  </Col>
                                  <Col className="gutter-row" span={6}>
                                    <CurrencyFormat
                                      style={{
                                        border: "1px solid #d9d9d9",
                                        borderRadius: "5px",
                                        width: "100%",
                                        margin: "2px 0",
                                      }}
                                      value={getIntegerValueByKey(
                                        payload,
                                        "bbmStockUnit.trustPrice"
                                      )}
                                      thousandSeparator={"."}
                                      decimalSeparator={","}
                                      prefix={"Rp "}
                                      placeholder={"Rp 0"}
                                      // disabled={rawData ? (rawData.isAgree || rawData.status !== "New") ? true : false : true}
                                      onValueChange={(values) => {
                                        const {
                                          formattedValue,
                                          value,
                                          floatValue,
                                        } = values;
                                        this.calculateData(
                                          "bbmStockUnit",
                                          floatValue
                                        );
                                      }}
                                    />
                                  </Col>
                                  <Col className="gutter-row" span={6}>
                                    <div style={{ textAlign: "right" }}>
                                      <p>
                                        <CurrencyFormat
                                          style={{ marginBottom: 0 }}
                                          value={getIntegerValueByKey(
                                            payload,
                                            "bbmStockUnit.priceTotal"
                                          )}
                                          displayType={"text"}
                                          decimalSeparator={","}
                                          thousandSeparator={"."}
                                          prefix={"Rp "}
                                        />
                                      </p>
                                    </div>
                                  </Col>
                                </Row>
                                <Row
                                  gutter={{ xs: 8, sm: 16, md: 24, lg: 32 }}
                                  justify="space-between"
                                  align="middle"
                                  style={{
                                    display: "flex",
                                    alignItems: "center",
                                  }}>
                                  <Col className="gutter-row" span={6}>
                                    <p style={{ marginBottom: 0 }}>Others</p>
                                  </Col>
                                  <Col className="gutter-row" span={6}>
                                    {this.defaultValueContent(
                                      defaultPayload.others.odooPrice
                                    )}
                                  </Col>
                                  <Col className="gutter-row" span={6}>
                                    <CurrencyFormat
                                      style={{
                                        border: "1px solid #d9d9d9",
                                        borderRadius: "5px",
                                        width: "100%",
                                        margin: "2px 0",
                                      }}
                                      value={getIntegerValueByKey(
                                        payload,
                                        "others.trustPrice"
                                      )}
                                      thousandSeparator={"."}
                                      decimalSeparator={","}
                                      prefix={"Rp "}
                                      placeholder={"Rp 0"}
                                      // disabled={rawData ? (rawData.isAgree || rawData.status !== "New") ? true : false : true}
                                      onValueChange={(values) => {
                                        const {
                                          formattedValue,
                                          value,
                                          floatValue,
                                        } = values;
                                        this.calculateData(
                                          "others",
                                          floatValue
                                        );
                                      }}
                                    />
                                  </Col>
                                  <Col className="gutter-row" span={6}>
                                    <div style={{ textAlign: "right" }}>
                                      <p>
                                        <CurrencyFormat
                                          style={{ marginBottom: 0 }}
                                          value={getIntegerValueByKey(
                                            payload,
                                            "others.priceTotal"
                                          )}
                                          displayType={"text"}
                                          decimalSeparator={","}
                                          thousandSeparator={"."}
                                          prefix={"Rp "}
                                        />
                                      </p>
                                    </div>
                                  </Col>
                                </Row>
                                <Row
                                  gutter={{ xs: 8, sm: 16, md: 24, lg: 32 }}
                                  justify="space-between"
                                  align="middle"
                                  style={{
                                    display: "flex",
                                    alignItems: "center",
                                    marginTop: 10,
                                    marginBottom: 10,
                                    marginLeft: -16,
                                    marginRight: -16,
                                  }}>
                                  <Col className="gutter-row" span={6}>
                                    <p
                                      style={{
                                        fontWeight: "bold",
                                        marginBottom: 0,
                                      }}>
                                      Total Cost
                                    </p>
                                  </Col>
                                  <Col className="gutter-row" span={6}>
                                    <div style={{ textAlign: "center" }}>
                                      <p style={{ marginBottom: 0 }}></p>
                                    </div>
                                  </Col>
                                  <Col className="gutter-row" span={6}>
                                    <p style={{ marginBottom: 0 }}></p>
                                  </Col>
                                  <Col className="gutter-row" span={6}>
                                    <div style={{ textAlign: "right" }}>
                                      <p
                                        style={{
                                          fontWeight: "bold",
                                          marginBottom: 0,
                                        }}>
                                        <CurrencyFormat
                                          style={{
                                            width: "100%",
                                            margin: "2px 0",
                                          }}
                                          value={getIntegerValueByKey(
                                            payload,
                                            "totalCost"
                                          )}
                                          thousandSeparator={"."}
                                          decimalSeparator={","}
                                          displayType={"text"}
                                          prefix={"Rp "}
                                        />
                                      </p>
                                    </div>
                                  </Col>
                                </Row>
                                <Row
                                  gutter={{ xs: 8, sm: 16, md: 24, lg: 32 }}
                                  justify="space-between"
                                  align="middle"
                                  style={{
                                    display: "flex",
                                    alignItems: "center",
                                    marginTop: 10,
                                    marginBottom: 10,
                                    marginLeft: -16,
                                    marginRight: -16,
                                  }}>
                                  <Col className="gutter-row" span={6}>
                                    <p
                                      style={{
                                        fontWeight: "bold",
                                        marginBottom: 0,
                                      }}>
                                      Available Margin
                                    </p>
                                  </Col>
                                  <Col className="gutter-row" span={6}>
                                    <div style={{ textAlign: "center" }}>
                                      <p style={{ marginBottom: 0 }}></p>
                                    </div>
                                  </Col>
                                  <Col className="gutter-row" span={6}>
                                    <p style={{ marginBottom: 0 }}></p>
                                  </Col>
                                  <Col className="gutter-row" span={6}>
                                    <div style={{ textAlign: "right" }}>
                                      <CurrencyFormat
                                        style={{
                                          width: "100%",
                                          margin: "2px 0",
                                        }}
                                        value={getIntegerValueByKey(
                                          payload,
                                          "availableMargin"
                                        )}
                                        thousandSeparator={"."}
                                        decimalSeparator={","}
                                        displayType={"text"}
                                        prefix={"Rp "}
                                      />
                                    </div>
                                  </Col>
                                </Row>

                                <Row
                                  gutter={{ xs: 8, sm: 16, md: 24, lg: 32 }}
                                  style={{
                                    marginTop: 10,
                                    marginBottom: 10,
                                    marginLeft: 0,
                                    marginRight: 0,
                                    display: "flex",
                                    alignItems: "center",
                                  }}>
                                  <Col className="gutter-row" span={12}>
                                    <div style={{ marginBottom: 5 }}>
                                      Discounts - Subsidi DP
                                    </div>
                                    <Row
                                      gutter={{ xs: 8, sm: 16, md: 24, lg: 32 }}
                                      style={{
                                        display: "flex",
                                        alignItems: "center",
                                      }}>
                                      <Col className="gutter-row" span={10}>
                                        <div style={{ display: "flex" }}>
                                          <CurrencyFormat
                                            style={{
                                              border: "1px solid #d9d9d9",
                                              borderRadius: 5,
                                              width: "100%",
                                              padding: "0 10px",
                                            }}
                                            value={getFloatValueByKey(
                                              payload,
                                              "discountSubsidiDP.discount"
                                            )}
                                            thousandSeparator={"."}
                                            decimalSeparator={","}
                                            disabled={true}
                                            placeholder={"Diskon"}
                                          />
                                          <div
                                            style={{
                                              padding: 10,
                                              marginLeft: -30,
                                            }}>
                                            %
                                          </div>
                                        </div>
                                      </Col>
                                      <Col className="gutter-row" span={14}>
                                        <div style={{ display: "flex" }}>
                                          <div
                                            style={{
                                              padding: 10,
                                              backgroundColor: "#EAEAEA",
                                              borderRadius: "5px 0px 0px 5px",
                                            }}>
                                            Rp.
                                          </div>
                                          <CurrencyFormat
                                            style={{
                                              border: "1px solid #d9d9d9",
                                              borderRadius: "5px",
                                              width: "100%",
                                              padding: "0 10px",
                                            }}
                                            value={getIntegerValueByKey(
                                              payload,
                                              "discountSubsidiDP.priceTotal"
                                            )}
                                            thousandSeparator={"."}
                                            decimalSeparator={","}
                                            placeholder={"0"}
                                            // disabled={rawData ? (rawData.isAgree || rawData.status !== "New") ? true : false : true}
                                            onValueChange={(values) => {
                                              const {
                                                formattedValue,
                                                value,
                                                floatValue,
                                              } = values;
                                              this.calculateData(
                                                "discountSubsidiDP",
                                                floatValue
                                              );
                                            }}
                                          />
                                        </div>
                                      </Col>
                                    </Row>
                                  </Col>
                                  <Col className="gutter-row" span={12}>
                                    <div style={{ marginBottom: 5 }}>
                                      Discounts
                                    </div>
                                    <Row
                                      gutter={{ xs: 8, sm: 16, md: 24, lg: 32 }}
                                      style={{
                                        display: "flex",
                                        alignItems: "center",
                                      }}>
                                      <Col className="gutter-row" span={10}>
                                        <div style={{ display: "flex" }}>
                                          <CurrencyFormat
                                            style={{
                                              border: "1px solid #d9d9d9",
                                              borderRadius: 5,
                                              width: "100%",
                                              padding: "0 10px",
                                            }}
                                            value={getFloatValueByKey(
                                              payload,
                                              "discount.discount"
                                            )}
                                            thousandSeparator={"."}
                                            decimalSeparator={","}
                                            disabled={true}
                                          />
                                          <div
                                            style={{
                                              padding: 10,
                                              marginLeft: -30,
                                            }}>
                                            %
                                          </div>
                                        </div>
                                      </Col>
                                      <Col className="gutter-row" span={14}>
                                        <div style={{ display: "flex" }}>
                                          <div
                                            style={{
                                              padding: 10,
                                              backgroundColor: "#EAEAEA",
                                              borderRadius: "5px 0px 0px 5px",
                                            }}>
                                            Rp.
                                          </div>
                                          <CurrencyFormat
                                            style={{
                                              border: "1px solid #d9d9d9",
                                              borderRadius: "0px 5px 5px 0px",
                                              width: "100%",
                                              padding: "0 10px",
                                            }}
                                            value={getIntegerValueByKey(
                                              payload,
                                              "discount.priceTotal"
                                            )}
                                            thousandSeparator={"."}
                                            decimalSeparator={","}
                                            disabled={true}
                                          />
                                        </div>
                                      </Col>
                                    </Row>
                                  </Col>
                                </Row>

                                <Row
                                  gutter={{ xs: 8, sm: 16, md: 24, lg: 32 }}
                                  justify="space-between"
                                  align="middle"
                                  style={{
                                    display: "flex",
                                    alignItems: "center",
                                    marginTop: 10,
                                    marginBottom: 10,
                                    marginLeft: -16,
                                    marginRight: -16,
                                  }}>
                                  <Col className="gutter-row" span={12}>
                                    <p
                                      style={{
                                        fontWeight: "bold",
                                        marginBottom: 0,
                                      }}>
                                      PROFIT
                                    </p>
                                  </Col>
                                  <Col className="gutter-row" span={12}>
                                    <div style={{ textAlign: "right" }}>
                                      <p style={{ fontWeight: "bold" }}>
                                        (
                                        <CurrencyFormat
                                          style={{
                                            width: "100%",
                                            margin: "2px 0",
                                          }}
                                          value={getFloatValueByKey(
                                            payload,
                                            "profit.profitPercent"
                                          )}
                                          thousandSeparator={"."}
                                          decimalSeparator={","}
                                          decimalScale={2}
                                          displayType={"text"}
                                        />{" "}
                                        %)
                                        <span style={{ fontWeight: "normal" }}>
                                          <CurrencyFormat
                                            style={{
                                              width: "100%",
                                              margin: "2px",
                                            }}
                                            value={getIntegerValueByKey(
                                              payload,
                                              "profit.priceTotal"
                                            )}
                                            thousandSeparator={"."}
                                            decimalSeparator={","}
                                            displayType={"text"}
                                            prefix={"Rp "}
                                          />
                                        </span>
                                      </p>
                                    </div>
                                  </Col>
                                </Row>
                              </div>
                            ) : null}
                          </div>
                        ) : null}
                      </div>
                    </div>
                  ) : null}
                </Form>
              </Spin>
            </Card>
          </Col>
        </Row>
      </div>
    );
  }
}

let mapStateToProps = ({ Auth }) => ({ Auth });

export default Form.create()(
  connect(mapStateToProps)(EApprovalSearchLicensePlate)
);



// WEBPACK FOOTER //
// src/components/Dashboard/EApproval/EApprovalSearchLicensePlate.js